import gql from "graphql-tag";


export const DELETE_CHECK_IN_MUTATION = gql`
mutation deleteUserCheckIn($id: ID!) {
  deleteUserCheckIn(id: $id) {
    ok
  }
}
`

export const UPDATE_ASSESSMENT_QUERY = gql`
mutation editAssessment($input:EditAssessmentInput!) {
  editAssessment(input: $input) {
    success
    error
  }
}
`;